// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BtnWithWin_TheComp__WSxFe"};